import React, { FC } from 'react';

import Clock from '@material-ui/icons/Schedule';
import moment from 'moment';
import Picker from 'rc-time-picker';
import { DATE_RFC2822 } from '../../contrib/utils';

import 'rc-time-picker/assets/index.css';

interface IProps {
  label: string;
  value?: string;
  onChange?: any;
  disabled?: boolean;
}

const format = 'h:mm a';

const TimePicker: FC<IProps> = props => {
  const { label, onChange, value = moment().format(DATE_RFC2822), disabled } = props;

  const setValue = (event: any) => {
    if (event) {
      onChange(event);
    }
  };

  return (
    <div className="timepicker">
      <span className="label">{label}</span>

      <Picker
        className="new-timepicker"
        disabled={disabled}
        format={format}
        inputIcon={<Clock color="primary" className="clock-icon" />}
        onChange={setValue}
        popupClassName="timepicker-panel staff-scope"
        showSecond={false}
        use12Hours={true}
        value={moment(value)}
      />
    </div>
  );
};

export { TimePicker };
